import type { LegalConsentProps } from '@paypalcorp/pp-react-checkbox-weasley-v7';
import { LegalConsent as LegalConsentppv7 } from '@paypalcorp/pp-react-checkbox-weasley-v7';
import styled from '@emotion/styled';

type LS = {
  customStyle?: string;
};
export const LegalConsent = styled(LegalConsentppv7)<LegalConsentProps & LS>`
  label > span > span {
    font-size: ${({ customStyle }) =>
      customStyle === 'ForcedGuestStyles' ? '18px' : '14px'};
    line-height: ${({ customStyle }) =>
      customStyle === 'ForcedGuestStyles' ? '24px' : '20px'};
    color: ${({ customStyle }) =>
      customStyle === 'ForcedGuestStyles' ? '#001435' : 'rgb(84, 93, 104)'};
  }
`;
